export const HEADER_TEXT = 'Something went wrong'
export const LOG_OUT = 'Log Out'
export const SUB_HEADER_TEXT = 'Please log out and try again.'



// WEBPACK FOOTER //
// ./src/components/AuthZeroErrorMessage/constants.js